<template>
    <v-layout>
        <v-flex v-if="itemCount > 0" xs8>
            <text-field-label
                v-for="index in itemCount"
                ref="text-field"
                :key="index"
                v-model="step[index - 1].name"
                :editable="isEditable"
                :disabled="isDisabled"
                :rules="[
                    rules.required,
                    rules.maxChars(step[index - 1].name, 32),
                    rules.duplication(step[index - 1].name, index - 1, step, 'Step_Name'),
                ]"
                :placeholder="placeholderData"
                :append-icon="isDetailsPage && !isIconDisabled ? 'edit' : ''"
                required
                @keydown.13="$emit('keydown', { keyCode: 13, type: 'keydown' })"
            />
        </v-flex>
        <v-flex v-if="itemCount == 0" xs8>
            <label>{{ $t('No_Step') }}</label>
        </v-flex>
        <v-flex class="ml-1">
            <v-layout>
                <v-tooltip :disabled="!isMaxCount" bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            :disabled="!isMaxCount || !isNotTemplates || isDisabled"
                            fab
                            small
                            color="accent"
                            @click="addStepItems()"
                            v-on="on"
                        >
                            <v-icon> add </v-icon>
                        </v-btn>
                    </template>
                    <span>{{ $t('Add_Step') }}</span>
                </v-tooltip>
            </v-layout>
        </v-flex>
        <v-flex class="ml-2">
            <v-layout>
                <v-tooltip :disabled="!isMinCount" bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            :disabled="!isMinCount || !isNotTemplates || isDisabled"
                            fab
                            small
                            color="accent"
                            @click="deleteStepItems()"
                            v-on="on"
                        >
                            <v-icon> remove </v-icon>
                        </v-btn>
                    </template>
                    <span>{{ $t('Delete_Step') }}</span>
                </v-tooltip>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import InputValidation from '../../mixins/InputValidation';
import { WorkflowStepInfo } from '../../store/modules/workflow/types';
import TextFieldLabel from './TextFieldLabel.vue';

const namespace = 'workflow';

@Component({
    name: 'StepItems',
    components: {
        TextFieldLabel,
    },
})
export default class StepItems extends mixins(InputValidation) {
    @Prop({ default: [] }) value: Array<WorkflowStepInfo>;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: true }) editable: boolean;
    @Prop({ default: true }) notTemplates: boolean;
    @Prop({ default: '' }) placeholder: string;
    @Prop({ default: [] }) stepItems: Array<WorkflowStepInfo>;
    @Prop({ default: 0 }) count: number;
    @Prop({ default: 0 }) maxCount: number;
    @Prop({ default: 0 }) minCount: number;
    @Prop({ default: false }) isDetailsPage: boolean;
    @Prop({ default: false }) isIconDisabled: boolean;
    @Watch('step')
    onValueChanged(val: Array<WorkflowStepInfo>): void {
        this.stepList = val;
    }
    @Watch('stepList')
    onItemsChanged(val: Array<WorkflowStepInfo>): void {
        this.$emit('input', val);
    }
    @Watch('count')
    onCountChanged(val: number): void {
        this.stepCount = val;
    }
    @Watch('stepCount')
    onStepCountChanged(val: number): void {
        this.$emit('count', val);
    }

    stepList: Array<WorkflowStepInfo> = [];
    stepCount = 1;

    /**
     * lifecycle hooks
     */
    created() {
        this.stepCount = this.count;
    }

    /**
     * getter
     */
    get step(): Array<WorkflowStepInfo> {
        return this.value;
    }
    get placeholderData(): string {
        return this.placeholder;
    }
    get isMinCount(): boolean {
        return this.minCount < this.stepCount;
    }
    get isMaxCount(): boolean {
        return this.stepCount < this.maxCount;
    }
    get itemCount(): number {
        return this.stepCount;
    }
    get isEditable(): boolean {
        return this.editable;
    }
    get isNotTemplates(): boolean {
        return this.notTemplates;
    }
    get isDisabled(): boolean {
        return this.disabled;
    }

    /**
     * methods
     */
    addStepItems() {
        if (this.stepCount < this.maxCount) {
            let count = this.stepCount;
            this.step.push(this.stepItems[count]);
            this.stepCount++;
        }
    }
    deleteStepItems() {
        if (this.minCount < this.stepCount) {
            this.step.pop();
            this.stepCount--;
        }
    }

    setStepReset() {
        this.stepList.splice(-this.stepList.length);
        for (let count = 0; count < this.stepItems.length; count++) {
            this.stepList.push(this.stepItems[count]);
        }
    }
    dataInit(): void {
        this.setStepReset();
        this.stepCount = 1;
    }
    reset(): void {
        this.dataInit();
    }
}
</script>
